import React from 'react'

export default function Navbar({ userEmail }) {
  return (
    <div className="w-full h-14 bg-gray-900 border-b border-gray-800 flex items-center justify-between px-6 text-gray-300">
      <div className="font-semibold text-lg">Dashboard</div>
      <div className="text-sm">
        Logged in as{' '}
        <span className="text-blue-400 font-medium">{userEmail}</span>
      </div>
    </div>
  )
}
